export default __webpack_public_path__ + "static/Core-Blog-Image-ffbaf221fe4f90df9091e5131a785a05.png";